import { Component, OnInit } from "@angular/core";
import { BaseService } from "@app/shared/services/base.service";
import { CommunicationService } from "@app/shared/services/communication.service";
import {
    ALLOWED_FILE_TYPES,
    ERROR_MESSAGE_GETTING_DATA,
    ERROR_SENDING_REQUEST,
    FILE_SIZE_LIMIT,
} from "@app/shared/services/display.messages";
import { ShareVars } from "@app/shared/services/share.vars";
import { IMAGES_URL, SEND_MESSAGE_URL } from "@app/shared/services/urls_b2b";
import { environment } from "environments/environment";

@Component({
    selector: "app-communication",
    templateUrl: "./communication.component.html",
    styleUrls: ["./communication.component.scss"],
})
export class CommunicationComponent implements OnInit {
    communications = [];
    sentCommunications = [];
    showModalCom = false;
    selectedCommunication: any = {};

    sentLoading = false;
    loading = false;
    skeletonRows = Array(10).fill(0);

    // received communications
    page = 1;
    perPage = 25;
    pagesCount = 1;
    total = 0;
    numbers = [];

    // sent communications
    sentPage = 1;
    sentPerPage = 25;
    sentPagesCount = 1;
    sentTotal = 0;
    sentNumbers = [];

    subject = "";
    content = "";
    files = [];
    openMessagModal = false;
    modules = {
        toolbar: {
            container: [
                ["bold", "italic", "underline"],
                [{ header: [1, 2, 3, false] }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link"],
                ["clean"],
            ],
        },
    };
    uploadingFile = false;
    sendingMessage = false;
    textLength = 0;
    activeTab: "received" | "sent" = "received";
    clientAssets;

    typeDict = {
        "ADMIN_BOOKING": "Message to Admin regarding a booking",
        "AGENCY_BOOKING": "Message to Agency regarding a booking",
        "ADMIN": "Message to Admin",
        "AGENCY": "Message to Agency",
    };

    constructor(
        private baseService: BaseService,
        private communicationService: CommunicationService,
    ) {
        ShareVars.isBusy = false;
    }

    ngOnInit() {
        this.getAllcoms();
        this.getSentComs();
        this.clientAssets = environment.assets.toLowerCase();
    }

    getAllcoms() {
        if (this.loading) return;
        this.loading = true;
        this.communicationService
            .getAll({ page: this.page, per_page: this.perPage })
            .subscribe((data) => {
                this.loading = false;
                this.numbers = [];
                this.communications = data.communication.data;
                this.total = data.communication.total;
                let x = this.total;
                let y = this.perPage;
                this.pagesCount = (x - (x % y)) / y;
                if (this.pagesCount == 0) {
                    this.pagesCount = 1;
                }
                for (let i = 0; i < this.pagesCount; i++) {
                    this.numbers.push(i);
                }
            });
    }

    getSentComs() {
        if (this.sentLoading) return;
        this.sentLoading = true;
        this.communicationService
            .getSent({ page: this.sentPage, per_page: this.sentPerPage })
            .subscribe((data) => {
                this.sentLoading = false;
                this.sentNumbers = [];
                this.sentCommunications = data.communication.data;
                this.sentTotal = data.communication.total;
                let x = this.sentTotal;
                let y = this.sentPerPage;
                this.sentPagesCount = (x - (x % y)) / y;
                if (this.sentPagesCount == 0) {
                    this.sentPagesCount = 1;
                }
                for (let i = 0; i < this.sentPagesCount; i++) {
                    this.sentNumbers.push(i);
                }
            });
    }

    openAttachment(file_path: string) {
        window.open(environment.staticApi + file_path);
    }

    openCommunication(communication) {
        this.showModalCom = true;
        this.selectedCommunication = communication;
        if (communication.read || this.activeTab === "sent") return;
        this.baseService.unreadMessages--;
        this.communicationService
            .markAsRead({ communication_id: communication.id })
            .subscribe(
                (data) => {
                    communication.read = true;
                },
                (error) => {
                    this.showError(ERROR_MESSAGE_GETTING_DATA);
                    console.error(
                        "Error marking communication as read:",
                        error,
                    );
                },
            );
    }

    buildLink(selectedCommunication) {
        switch (selectedCommunication.product) {
            case "FLIGHT":
                return `/b2b/manage-flight-bookings/eticket/${selectedCommunication.booking_id}#${selectedCommunication.id}`;
            case "HOTEL":
                return `/b2b/manage-hotel-bookings/voucher/${selectedCommunication.booking_id}#${selectedCommunication.id}`;
            default:
                return `/b2b/manage-flight-bookings/eticket/${selectedCommunication.booking_id}#${selectedCommunication.id}`;
        }
    }

    setTab(tab: "received" | "sent") {
        this.activeTab = tab;
    }

    openMessageModal() {
        this.openMessagModal = true;
    }

    closeMessageModal() {
        this.openMessagModal = false;
    }

    closeCommMsgModal() {
        this.showModalCom = false;
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            return;
        }
        const selectedFile = input.files[0];
        if (!selectedFile) {
            alert("Please select a file first");
            return;
        }
        if (
            selectedFile.type &&
            !selectedFile.type.includes("image") &&
            !selectedFile.type.includes("pdf")
        ) {
            this.showError(ALLOWED_FILE_TYPES);
            return;
        }
        if (selectedFile.size > 5 * 1024 * 1024) {
            this.showError(FILE_SIZE_LIMIT);
            return;
        }

        this.uploadingFile = true;
        const formData = new FormData();
        formData.append("file", selectedFile);
        this.baseService
            .tokenPostRequest(IMAGES_URL + "/api/files/communication", formData)
            .subscribe(
                (data) => {
                    this.uploadingFile = false;
                    if (!data || !data.path) {
                        this.showError(ERROR_SENDING_REQUEST);
                        return;
                    }
                    if (data.extension === "pdf") {
                        this.content += ` <br><br><a  href="${environment.staticApi}${data.path}" style="cursor: pointer;" target="_blank">${data.name}</a>`;
                    } else {
                        this.content += ` <br><br><img src="${environment.staticApi}${data.path}" alt="${data.name}">`;
                    }
                    this.files.push(data);
                },
                (error) => {
                    this.uploadingFile = false;
                    this.showError(ERROR_SENDING_REQUEST);
                    console.error("Error uploading file:", error);
                },
            );
    }

    onContentChanged(event: any) {
        this.textLength = event.editor.getText().trim().length;
    }

    canSendMessage(): boolean {
        return (
            this.subject.trim() !== "" &&
            this.textLength > 0 &&
            this.textLength < 5000 &&
            !this.uploadingFile &&
            !this.sendingMessage
        );
    }

    sendMessage() {
        if (!this.canSendMessage()) {
            return;
        }
        this.sendingMessage = true;
        let payload = {
            subject: this.subject,
            body: this.content,
            files: this.files.map((file) => file.path),
        };
        this.communicationService.sendMessage(payload).subscribe(
            (data) => {
                this.sendingMessage = false;
                if (data && data.success) {
                    this.closeMessageModal();
                    this.subject = "";
                    this.content = "";
                    this.files = [];
                    this.getSentComs()
                    return;
                }
                this.showError(ERROR_SENDING_REQUEST);
            },
            (error) => {
                this.sendingMessage = false;
                console.error("Error sending message:", error);
                this.showError(ERROR_SENDING_REQUEST);
            },
        );
    }

    showError(msg) {
        console.error(msg);
        ShareVars.showError = true;
        ShareVars.errorTitle = "ERROR";
        ShareVars.errorMessage = msg;
    }
}
